import { Utilities } from "@learningblocks/exp-constants";
const { VISIBILITY, checkIfSelectionValid } = Utilities;
const NEXT_COMPONENT = "nextComponent";
const FINAL_POINT = "finalPoint";

//checks if selected option is correct and updates accordingly
export function submitAnswer(state, payload) {
  return {
    ...state,
    currentChapter: updateSubmissionInCurrentChapter(
      state.currentChapter,
      payload
    ),
  };
}

function updateSubmissionInCurrentChapter(currentChapter, payload) {
  return {
    ...currentChapter,
    components: updateSubmissionInComponents(
      currentChapter.components,
      payload
    ),
  };
}

/**
 *
 * @param {'Array<Object>'} components array of components
 * @param {'number'} payload component ID
 * @returns
 */
function updateSubmissionInComponents(components, payload) {
  const { newcomponents } = components.reduce(
    (acc, component) => {
      // updating submitted CSCQ component
      if (component.id === payload && component.options) {
        component = updateOptionsComponent(component);
        if (Object.hasOwn(component, NEXT_COMPONENT)) {
          acc.forward = {
            complete: component.complete,
            nextComponent: component.nextComponent,
          };
        }
      }

      // updating submitted CSCQ_COLOR component
      if (component.id === payload && component.typedOptions) {
        component = updateTypedOptionsComponent(component);
        if (Object.hasOwn(component, NEXT_COMPONENT)) {
          acc.forward = {
            complete: component.complete,
            nextComponent: component.nextComponent,
          };
        }
      }

      //function for handling edgecase - components with finalPoint prpoerty will display rest of the components when the property is set to false
      component = updateFinalPointIfExists(component);

      if (
        acc.forward &&
        acc.forward.complete &&
        acc.forward.nextComponent === component.id
      ) {
        // updating forward component and setting its visibility
        component = { ...component, visibility: VISIBILITY.VISIBLE };
        acc.forward = null;
      }

      acc.newcomponents = [...acc.newcomponents, component];
      return acc;
    },
    {
      forward: null,
      newcomponents: [],
    }
  );
  return newcomponents;
}

function updateOptionsComponent(component) {
  if (checkIfSelectionValid(component)) {
    component.options = component.options.map(updateSelectedOption);
    component.complete = updateCSCQComplete(
      component.options,
      component.answerId
    );
    if (component.totalAttempts !== -10) {
      component.totalAttempts -= 1;
    }
  }
  return component;
}

function updateTypedOptionsComponent(component) {
  if (checkIfSelectionValid(component)) {
    component.typedOptions = component.typedOptions.map(updateSelectedOption);
    component.complete = updateCSCQComplete(
      component.typedOptions,
      component.answerId
    );
    if (component.totalAttempts !== -10) {
      component.totalAttempts -= 1;
    }
  }
  return component;
}

function updateSelectedOption(option) {
  if (option.selected === true) {
    option.disabled = true;
  }
  return { ...option };
}

const ALL_CORRECT_ANSWERS = -1;
const updateCSCQComplete = (options, answerId) => {
  if (answerId === ALL_CORRECT_ANSWERS) return true;
  const selectedOptions = options.reduce((selected, option) => {
    if (option.selected) {
      selected.push(option.id);
    }
    return selected;
  }, []);
  return answerId.every((answer) => selectedOptions.includes(answer));
};

function updateFinalPointIfExists(component) {
  // updating finalPoint to display rest of contents in section
  if (Object.hasOwn(component, FINAL_POINT) && component.complete) {
    component = { ...component, finalPoint: false };
    return component;
  } else return component;
}
